import { useTranslation } from "react-i18next";

export default function UniversitySupport({ compact = false }) {
    const { t } = useTranslation();
    return (
        <div className={`h-full min-h-0 flex flex-col items-center justify-center text-center ${compact ? "p-[0.8vh_2vw] gap-[0.6vh]" : "p-[2vh_3vw] gap-[1.8vh]"}`}>
            <img
                src="/partners/stu-logo.png"
                alt="Saginov Technical University"
                className={`w-[85%] flex-none object-contain ${compact ? "h-[4vh]" : "h-[8vh]"}`}
            />
            <div className="w-[5vh] h-[0.25vh] flex-none rounded-full bg-[#C6A25A]" aria-hidden="true" />
            <p className={`max-w-[30ch] font-medium text-[#515C70] ${compact ? "text-[1.2vh] leading-snug" : "text-[1.8vh] leading-relaxed"}`}>
                {t("routeList.grant_support_description")}
            </p>
        </div>
    );
}
